import React from 'react';
import MaskedInputField from 'commons/components/FormFields/MaskedInputField';

interface FormikMaskedInputFieldProps {
    /** props passed to the field */
    field: any,
    /** props related to the formik form such as errors and touched flags */
    form: any,
    /** onChange of the field */
    onChange: React.ChangeEventHandler
}

function FormikMaskedInputField(props: FormikMaskedInputFieldProps) {

    const field = props.field;

    return (
        <MaskedInputField
            {...field}
            {...props}
            error={props.form.errors[field.name]}
            name={field.name}
            onChange={(e: React.ChangeEvent) => { if (props.onChange) props.onChange(e); field.onChange(e); }}
            touched={props.form.touched[field.name]}
        />
    );

}

export default FormikMaskedInputField;